/**
 * Main navigation
 * @author Kate York
 * @author Oliver Boermans
 */

// Elements
//	.mobile-menu-container
//	.mobile-menu-container .site-main-menu__main-navigation
//	.mobile-menu-container > .site-main-menu__main-navigation
//	.mobile-menu-container .site-main-menu__main-navigation > li
//	.mega-menu-panel-trigger

//	.site-main-menu__more-button
//	.site-main-menu__nav-col
//	.site-main-menu__main-navigation .has-children
//	.site-main-menu__nav-col > .site-main-menu__main-navigation
//	.site-main-menu__nav-col > .site-main-menu__main-navigation > li
//	.mega-menu-panel
//	.mobile-menu-button
//	.main-menu-opened-overlay

//
// Utilities
import debug from "debug";
const MODULE_NAME = 'core/modules/navigation/mainnav';
const log = debug(MODULE_NAME);

//	jQuery element selectors for persistent elements
const selectors = {
	moreListItem: '[data-mainnav-more-item]',
	moreButton: '.site-main-menu__more-button',
	mainNavToggleButtons: '[data-mainnav-toggle]',
	mainNavCloseButtons: '[data-mainnav-close]',
	topHeaderPanelButtons: '.top-header-panel__global-navigation .top-header-panel__button',
	topHeaderPanelButtonsWithBorder: '.top-header-panel__button:not(.main-nav-panel__toggle-button)'
};

//	Contains references to persistent elements (jQuery objects)
const elements = {};

function findElements(selectors, elements) {
	for (var selector in selectors) {
		elements[selector] = $(selectors[selector]);
	}
	log('elements',elements);
}

//  1: Debounce window resize events
//  2: Prevent window resize events when scrolling or presenting the keyboard in mobile chrome or safari
function saneWindowResizeWidth (fn) {
    var executeFunction;
    var timeToExecute = 100,
        windowWidth = $(window).width();
    $(window).resize(function(){
        clearTimeout(executeFunction);
        executeFunction = setTimeout(function () { // 1
            if ($(window).width() !== windowWidth) { // 2
                windowWidth = $(window).width();
                fn();
            }
        }, timeToExecute);
    });
}

function setupMainNavMovingItems() {
    setTimeout(moveMainNavItems, 20);
    saneWindowResizeWidth(moveMainNavItems);
}

function moveMainNavItems() {
	$('.mega-menu-panel_has-level-2-navigation .mega-menu-panel__main-sub-navigation').show();

	// Put everything back in main nav
	$('.mobile-menu-container .site-main-menu__main-navigation > li').each(function(){
		var moveEl = $(this).detach();
		$('.site-main-menu__nav-col > .site-main-menu__main-navigation').append(moveEl);
	});

	// Put everything back in top nav
	$('.mobile-menu-container > .top-header-panel__global-navigation > li').each(function(){
		var moveEl = $(this).detach();
		$('.site-global-top-header .top-header-panel__global-navigation').append(moveEl);
	});

	// Move the top header panel back
	$('.mobile-menu-container .top-header-panel').each(function(){
		var moveEl = $(this).detach();
		$('.top-header-panel-wrapper').append(moveEl);
		moveEl.hide();
	});

	// Put everything back in top toggle section
	$('.mobile-menu-container > .top-header-panel__toggle-navigation > li ').each(function(){
		var moveEl = $(this).detach();
		$('.site-global-top-header .top-header-panel__toggle-navigation').append(moveEl);
	});


	// Move the items that don't fit back to mobile nav
	elements.moreListItem.show();

	var itemsWidth = 0;
	var availWidthTolerance = 20;
	var moveAll = false;
	var mobileNavHasItems = false;
	var moreButtonWidth = elements.moreListItem.innerWidth();
	var availWidth = $('.site-main-menu__nav-col').innerWidth();
	var lastAvailWidth = availWidth - availWidthTolerance - moreButtonWidth;
    var totalItems =  $('.site-main-menu__nav-col > .site-main-menu__main-navigation > li').length -1;

	elements.moreListItem.detach();

	if (!$('.site-main-menu__nav-col').is(':visible')) {
		moveAll = true;
	}

	$('.site-main-menu__nav-col > .site-main-menu__main-navigation > li').each(function(index){
		var width = $(this).outerWidth(true);
		var tmpWidth = width + itemsWidth;
		var isMore = $(this).is(elements.moreListItem[0]);
		var isLast = index == $('.site-main-menu__nav-col > .site-main-menu__main-navigation > li').length - 1;
		var doesntFit = tmpWidth >= lastAvailWidth && !isMore;
         if (totalItems == index) {
            doesntFit = tmpWidth >= availWidth && !isMore;
        }
		if (moveAll || doesntFit) {
			var moveEl = $(this).detach();
			$('.mobile-menu-container > .site-main-menu__main-navigation').append(moveEl);
			moveEl.show();
			mobileNavHasItems = true;
		}
		itemsWidth = tmpWidth;
	});

	$('.site-main-menu__nav-col > .site-main-menu__main-navigation').append(elements.moreListItem);

	if (moveAll) {
		$('.site-global-top-header .top-header-panel__toggle-navigation > li').each(function(index){
			var moveEl = $(this).detach();
			$('.mobile-menu-container > .top-header-panel__toggle-navigation').append(moveEl);
			moveEl.show();
			mobileNavHasItems = true;
		});
		$('.site-global-top-header .top-header-panel__global-navigation > li').each(function(index){
			var moveEl = $(this).detach();
			$('.mobile-menu-container > .top-header-panel__global-navigation').append(moveEl);
			moveEl.show();
			mobileNavHasItems = true;
		});

		$('.top-header-panel-wrapper > .top-header-panel').each(function(index){
			var moveEl = $(this).detach();
			$('.mobile-menu-container > .top-header-panel__toggle-navigation .main-nav-panel__toggle-button').closest('li').append(moveEl);
			moveEl.show();
			mobileNavHasItems = true;
		});
	}
	if (!mobileNavHasItems) {
		elements.moreListItem.hide();
	}

}

function toggleMobileMoreNav(event) {
	event.preventDefault();
	hideMainMenuSubPanels();
    $('.mobile-menu-button').removeClass('active');

	$('.mobile-menu-container').slideToggle(function(){
		if ($('.mobile-menu-container').is(':visible')) {
			$('.main-menu-opened-overlay').addClass('active');
			$('.mobile-menu-button').addClass('active');
			$('.site-main-menu__more-button').closest('li').addClass('active');

		}
	});
}

function bindHandlers() {
	$('.site-main-menu__main-navigation .has-children').click(function(e) {
		e.preventDefault();
		var button = $(this);
		var isSubItem = $(this).parent().find('.mega-menu-panel').length == 0;
		var showEl = !isSubItem ? $(this).parent().find('.mega-menu-panel') : $(this).closest('.columns').find('.mega-menu-panel__main-sub-navigation');
		var activeElement = !isSubItem ? $(this).parent() : $(this);
		toggleMainMenuSubPanel({
			button:button,
			activeElement: activeElement,
			showEl: showEl,
			isSubItem: isSubItem
		});
	});


    elements.mainNavToggleButtons.on('click', handleMainMenuToggle);

    $('[data-mainnav-toggle-focus-element="#q"]').on('click', function () {
        log('before.ClickTouchStart');
        $('#q').trigger('touchstart');
        $('#q').focus();
        $('#q').click();
        log('after.ClickTouchStart');
    });
    $('#q').on('touchstart', function () {
        log('before.TouchStart');
        $('#q').focus();
        log('after.TouchStart');
    });

	elements.mainNavCloseButtons.on('click', handleMainMenuClose);

	elements.topHeaderPanelButtons.on('click', handleTopHeaderPanelButtonsShow);

	elements.topHeaderPanelButtonsWithBorder.on('mouseover', handleTopHeaderPanelButtonBordersHide);

	elements.topHeaderPanelButtonsWithBorder.on('mouseout', handleTopHeaderPanelButtonBordersShow);

	$(window).click(function(e) {
		var target = e.target;
		if (!$(target).hasClass('main-content') && !$(target).hasClass('top-header-panel__sub-navigation-container') && $(target).closest('.top-header-panel__sub-navigation-container').length == 0) {
			handleTopHeaderPanelButtonsHide();
		}
	});

	window.addEventListener("hashchange", function() {
		$( document ).trigger('menu-opened-overlay-clicked');
		hideMainMenuSubPanels();
		$('.mobile-menu-container').hide();
	}, false);
	//	main nav buttons
	elements.moreButton.on('click', toggleMobileMoreNav);
	$('.mobile-menu-button').on('click', toggleMobileMoreNav);


	//	overlay closes menus
	$('.main-menu-opened-overlay').click(function(e) {
		$( document ).trigger('menu-opened-overlay-clicked');
		hideMainMenuSubPanels();
		$('.mobile-menu-container').hide();
	});
}

//	close all the things
function hideMainMenuSubPanels() {

    $('.mega-menu-panel.active:not(.keep-open)').each(function(){
        notifyMegaMenuClosed(this);
    });

	$('.site-header').removeClass('mega-menu-panel-open');
	$('.site-main-menu').removeClass('sub-menu-opened');
	$('.site-main-menu__more-button').closest('li').removeClass('active');
	$('.site-main-menu__main-navigation > li').removeClass('active');
	$('.top-header-panel__global-navigation > li > button').removeClass('active');
	$('.top-header-panel__toggle-navigation > li > button').removeClass('active');
	$('.mobile-menu-container .has-children').removeClass('active');
	$('.mega-menu-panel:not(.keep-open)').hide();
	$('.main-nav-panel__mega-menu-panel:not(.keep-open)').removeClass('active');
	$('.main-menu-opened-overlay').removeClass('active');
	$('.mobile-menu-button').removeClass('active');
	$('.mobile-menu-container .mega-menu-panel_has-level-2-navigation .mega-menu-panel__main-sub-navigation').hide().removeClass('active');
	$('.mobile-menu-container .mega-menu-panel_has-level-2-navigation .has-children').removeClass('active');
	$( document ).trigger('hide-main-menu-sub-panels');
	handleTopHeaderPanelButtonBordersShow();
}

function hideMainMenuLevel2SubPanels() {
	$('.mobile-menu-container .mega-menu-panel_has-level-2-navigation .has-children').removeClass('active');
	$('.mobile-menu-container .mega-menu-panel_has-level-2-navigation .mega-menu-panel__main-sub-navigation').hide().removeClass('active');
}

function handleMainMenuToggle() {
	var button = $(this);
	var showEl = button.attr('data-mainnav-toggle');
	var activeElement = button.attr('data-mainnav-toggle-active-element');
	var focusElement = button.attr('data-mainnav-toggle-focus-element');

	toggleMainMenuSubPanel({
		focusElement: $(focusElement).first(),
		activeElement: $(activeElement),
		showEl: $(showEl),
		button: button
	});
}

function handleMainMenuClose() {
	var button = $(this);
	var showEl = button.attr('data-mainnav-close');
	var activeElement = button.attr('data-mainnav-close-active-element');

	toggleMainMenuSubPanel({
		activeElement: $(activeElement),
		showEl: $(showEl),
		button: button
	});
}

function handleTopHeaderPanelButtonBordersHide() {
	elements.topHeaderPanelButtonsWithBorder.addClass('hide-border');
}

function handleTopHeaderPanelButtonBordersShow() {
	elements.topHeaderPanelButtonsWithBorder.removeClass('hide-border');
}

function handleTopHeaderPanelButtonsHide() {
	elements.topHeaderPanelButtons.removeClass('active');
}

function handleTopHeaderPanelButtonsShow(e) {
	e.stopPropagation();
	var isActive = $(this).hasClass('active');
	if (isActive) {
		$(this).removeClass('active');
	}
	else {
		elements.topHeaderPanelButtons.removeClass('active');
		hideMainMenuSubPanels();
		$(this).addClass('active');
	}

    //  is the menu in “overflow” mode?
    if ($('.mobile-menu-container').is(':visible')) {
        $('.main-menu-opened-overlay').addClass('active');
        $('.mobile-menu-button').addClass('active');
        $('.site-main-menu__more-button').closest('li').addClass('active');
    }
    else {
        $('.mobile-menu-button').removeClass('active');
    }
}


function toggleSubMenuPanel (opt) {
	const activeClassName = 'active';

	//	toggle button
	const button = opt.button;

	//	parent nav item li
	const activeElement = opt.activeElement;

	//	element to toggle
	const showEl = opt.showEl;

	//	is element to toggle active already?
	const toOpen = !showEl.hasClass(activeClassName);

	button.toggleClass(activeClassName, toOpen);
	activeElement.toggleClass(activeClassName, toOpen);
	showEl.toggleClass(activeClassName, toOpen);
}

function toggleMainMenuSubPanel(opt) {

	//	nav item li
	var activeElement = opt.activeElement,

	//	element to toggle
		showEl = opt.showEl,

	//	toggle button
		button = opt.button,

	//	element to focus
		focusElement = opt.focusElement,

	//	element to focus
		isSubItem = typeof opt.isSubItem !== 'undefined' ?  opt.isSubItem : false,

	// All buttons that toggle this panel
		toggleButtonAttr =  typeof button.attr('data-mainnav-toggle') !== 'undefined' ? button.attr('data-mainnav-toggle') : button.attr('data-mainnav-close'),

	// Site header wrapper element
		siteHeaderElement = $('.site-header'),

	 	toggleButtonsSelector = '[data-mainnav-toggle="'+toggleButtonAttr+'"]';

	//	check if item is already open
	//	are we opening or closing
	var isActive = $(activeElement).hasClass('active');

	//	top level parent
	var parentElement = $(activeElement).closest('.mobile-menu-container');
	if (typeof(parentElement) == 'undefined' || parentElement.length == 0) {
		$('.mobile-menu-container').hide();
	}

	//	hide element to toggle (may already be active)
	$(showEl).removeClass('active');
	$(toggleButtonsSelector).removeClass('active');


	//	close the other things
	if (!isSubItem) {
		hideMainMenuSubPanels();
	}
	else {
		hideMainMenuLevel2SubPanels();
	}

    if (!isSubItem && isActive) {
        notifyMegaMenuClosed(showEl[0]);
    }

	if (!isActive) {

        $(showEl).show(1, function(){
            if (focusElement != '') {
                $(focusElement).focus();
            }
            $(showEl).addClass('active');
            $(activeElement).addClass('active');
            $(toggleButtonsSelector).addClass('active');
            $(siteHeaderElement).addClass('mega-menu-panel-open');
            notifyMegaMenuOpened(showEl[0]);

            setTimeout(function(){
                $('.site-main-menu').addClass('sub-menu-opened');
                $('.main-menu-opened-overlay').addClass('active');
            }, 200);
		});

	}
	else if (focusElement != '') {
		$(activeElement).focus();
	}

	//	is the menu in “overflow” mode?
	if ($('.mobile-menu-container').is(':visible')) {
		$('.main-menu-opened-overlay').addClass('active');
		$('.mobile-menu-button').addClass('active');
		$('.site-main-menu__more-button').closest('li').addClass('active');
	}
	else {
		$('.mobile-menu-button').removeClass('active');
	}
}

function notifyMegaMenuOpened(megaMenuElement) {
    megaMenuElement.dispatchEvent(
        new CustomEvent("menu_opened", {
            bubbles: false,
        })
    );
}

function notifyMegaMenuClosed(megaMenuElement) {
    megaMenuElement.dispatchEvent(
        new CustomEvent("menu_closed", {
            bubbles: false,
        })
    );
}

export function exec (enquire) {
	$(document).ready(function() {
		findElements(selectors, elements);
		bindHandlers();
		setupMainNavMovingItems();
    });
}
export { exec as default };



// WEBPACK FOOTER //
// ./project/client/src/core/modules/navigation/index.js